import React from 'react';
import ReactPaginate from 'react-paginate';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import './pagination.style.scss';

type TPaginationProps = {
  postsPerPage: number;
  length: number;
  currentPage: number;
  handlePagination: (pageNumber: number) => void;
};

const Pagination = ({
  postsPerPage,
  length,
  currentPage,
  handlePagination,
}: TPaginationProps) => {
  const pageCount = Math.ceil(length / postsPerPage);

  return (
    <div className="pagination">
      <ReactPaginate
        pageCount={pageCount}
        forcePage={currentPage - 1}
        onPageChange={({ selected }) => handlePagination(selected + 1)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        breakLabel="..."
        previousLabel={
          <span className="prev_next">
            <FiArrowLeft /> Previous
          </span>
        }
        nextLabel={
          <span className="prev_next">
            Next <FiArrowRight />
          </span>
        }
        containerClassName="pagination_container"
        pageClassName="page_item"
        pageLinkClassName="page_link"
        activeClassName="active"
        breakClassName="dots"
        previousClassName="nav_button"
        nextClassName="nav_button"
        disabledClassName="disabled"
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default Pagination;
